import React, { useState } from "react";
import "../css/NewsLetter.css"; // Individual component styles

// Import your custom background and icon assets here
import newsletterBg from "../../images/Banner7.png"; 
import mailIcon from "../../images/HomeIcon.png"; 

function Newsletter() {
  const [email, setEmail] = useState("");

  const handleSubscribe = (e) => {
    e.preventDefault();
    alert(`Subscribed successfully with: ${email}`);
    setEmail("");
  };

  return (
    <section 
      className="newsletter-section" 
      style={{ backgroundImage: `url(${newsletterBg})` }}
    >
      <div className="container position-relative">
        
        {/* Centered Top Circle Floating Icon */}
        <div className="newsletter-floating-circle">
          <img src={mailIcon} alt="Mail Icon" className="newsletter-icon" />
        </div>

        {/* Main Form Box Container */}
        <div className="row justify-content-center">
          <div className="col-lg-8 text-center newsletter-content-box">
            
            <h2 className="newsletter-heading">Stay Connected With Us</h2>
            <p className="newsletter-subtext">
              Subscribe to our monthly briefing for premium updates, framework deep-dives, and exclusive ecosystem releases.
            </p>

            {/* Sleek Inline Email Subscription Form */}
            <form onSubmit={handleSubscribe} className="newsletter-form-wrapper">
              <div className="input-group-sleek">
                <input 
                  type="email" 
                  className="sleek-input" 
                  placeholder="Enter your email address..." 
                  value={email} 
                  onChange={(e) => setEmail(e.target.value)}
                  required 
                />
                <button type="submit" className="btn sleek-subscribe-btn">
                  SUBSCRIBE
                </button>
              </div>
            </form>

          </div>
        </div>

      </div>
    </section>
  );
}

export default Newsletter;